import axios from "axios";
import store from "@/redux/store";
import { closeLoading, openLoading } from "@/redux/slices/ui";
import { logout } from "@/redux/slices/auth";

const api = axios.create({
  baseURL: `${import.meta.env.VITE_URL_API}/api-checkout`,
  timeout: 60000,
  timeoutErrorMessage: "Não foi possível comunicar com o servidor",
});

/** Tenant resolvido pelo domínio — não deixa o Redux/DevTools trocar o header. */
let lockedTenantId: string | null = null;

export function lockApiTenantId(idTenant: number) {
  if (lockedTenantId == null && Number.isFinite(idTenant) && idTenant > 0) {
    lockedTenantId = String(idTenant);
  }
}

api.interceptors.request.use(function (config) {
  try {
    const idTenant =
      lockedTenantId || store.getState().tenant?.loginTenant?.IdTenant;
    if (idTenant) {
      config.headers["x-tenant-id"] = String(idTenant);
    }

    const token = store.getState().auth?.auth?.Token;
    const existingAuth =
      config.headers.Authorization || config.headers.authorization;
    if (token && !existingAuth) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (_) {
    console.error("Error Set Tenant Header");
  }
  return config;
});

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error?.response?.status === 401) {
      store.dispatch(openLoading(null));
      store.dispatch(logout());
      store.dispatch(closeLoading());
    }
    return Promise.reject(error);
  }
);

export default api;
